import React, {useEffect} from "react";
import bg from "./assets/internalImages/Enterprise/hero_section_bg_enterprise_.webp";
import front from "./assets/internalImages/Enterprise/hero_section_front_enterprise_.webp";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import "./Components/Hero.scss";

import KeyFeatures from "./Components/InternalPages/KeyFeatures";
import ClientReviews from "./Components/InternalPages/ClientReviews";
import IndustriesWeServe from "./Components/InternalPages/IndustriesWeServe";
import FAQSection from "./Components/InternalPages/FAQSection";

function Enterprise() {
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="minheight overflow-hidden">
      <section className="hero-section position-relative d-flex flex-column align-items-center justify-content-end">
        {/* Background */}
        <div className="image-section position-absolute top-0 start-0 w-100 h-100 z-n1">
          <img src={bg} alt="glare" className="hero-img w-100 h-100 object-fit-cover" />
          <div className="image-overlay position-absolute top-0 start-0 w-100 h-100"></div>
        </div>

        {/* Foreground Content */}
        <Container className="py-5 my-5">
          <Row className="justify-content-center">
            <Col xs={11}>
              <div
                className="shadow mt-5 p-4 p-md-5 rounded-4"
                style={{
                  background: "rgba(237, 241, 249, 0.7)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                }}
              >
                <Row className="g-5 align-items-center">
                  {/* Left Side */}
                  <Col xs={12} md={7}>
                    <img
                      src={front}
                      alt="Delivery Van"
                      className="w-100 rounded-4 mb-3"
                      style={{ height: "220px", objectFit: "cover" }}
                    />
                    <h2 className="fw-normal">
                      Effortless delivery infrastructure for growing businesses
                    </h2>
                    <p className="text-secondary fw-light mb-0">
                      From warehouse to doorstep, Packky manages dispatch, routing, and
                      tracking without the need for your own fleet.
                    </p>
                  </Col>

                  {/* Right Side - Form */}
                  <Col xs={12} md={5}>
                    <div className="bg-white shadow p-4 rounded-4">
                      <h5 className="mb-4 text-center">Fill Out For More Details</h5>
                      <Form>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control type="text" placeholder="Enter your Name*" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formCompany">
                          <Form.Control type="text" placeholder="Enter your Company Name*" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                          <Form.Control type="text" placeholder="Enter your Phone Number*" required />
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="formEmail">
                          <Form.Control type="email" placeholder="Enter your Email ID*" required />
                        </Form.Group>
                        <Button
                          type="submit"
                          className="w-100 text-white"
                          style={{ background: "#f39731", border: "none" }}
                        >
                          Get in Touch
                        </Button>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <KeyFeatures />
      <ClientReviews />
      <IndustriesWeServe />
      <FAQSection />
    </div>
  );
}

export default Enterprise;
